/* globals google */

'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
		(newUrl.indexOf('?') !== -1 ? '&' : '?') +
		Object.keys(params)
		    .map(function (key) {
		        return key + '=' + encodeURIComponent(params[key]);
		    })
		    .join('&');
    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var markers = [];
    var infowindow = new google.maps.InfoWindow();

    var myStyle = [
        {
            featureType: 'all',
            elementType: 'labels.text',
            stylers: [{ color: '#878787' }],
        },
        {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [{ color: '#f9f5ed' }],
        },
        {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [{ color: '#f5f5f5' }],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#c9c9c9' }],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [{ color: '#aee0f4' }],
        },
    ];

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(37.09024, -95.712891);
    var mapOptions = {
        scrollwheel: false,
        zoom: 16,
        center: latlng,
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);

    // ADA improvement: Hide raw map canvas from screen readers
    $('.map-canvas').attr({
        'aria-hidden': 'true',
        role: 'presentation',
    });

    var mapdiv = $('.map-canvas').attr('data-locations');
    map.setOptions({ styles: myStyle });
    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        path:
			'M13.5,30.1460153 L16.8554555,25.5 L20.0024287,25.5 C23.039087,25.5 25.5,' +
			'23.0388955 25.5,20.0024287 L25.5,5.99757128 C25.5,2.96091298 23.0388955,0.5 ' +
			'20.0024287,0.5 L5.99757128,0.5 C2.96091298,0.5 0.5,2.96110446 0.5,5.99757128 ' +
			'L0.5,20.0024287 C0.5,23.039087 2.96110446,25.5 5.99757128,25.5 L10.1445445,' +
			'25.5 L13.5,30.1460153 Z',
        fillColor: '#0070d2',
        fillOpacity: 1,
        scale: 1.1,
        strokeColor: 'white',
        strokeWeight: 1,
        anchor: new google.maps.Point(13, 30),
        labelOrigin: new google.maps.Point(12, 12),
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var lable = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name, // ADA: ensures screen reader gets a label
            icon: markerImg,
            label: { text: lable.toString(), color: 'white', fontSize: '16px' },
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml,
            });
            map.setZoom(15);
            map.setCenter(marker.getPosition());
            infowindow.open(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
        markers.push(marker);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.

    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }

    $(document)
        .off('click', '.js-marker-link')
        .on('click', '.js-marker-link', function () {
            var indexID = $(this).data('index-id') - 1;
            google.maps.event.trigger(markers[indexID], 'click');
        });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show().removeClass('d-none');
    } else {
        $('.store-locator-no-results').hide().addClass('d-none');
    }

    $resultsDiv
        .empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);

        // ADA: Add screen-reader-only accessible list
        var accessibleList =
			'<div class="sr-only" aria-hidden="false"><h2>Store Locations</h2><ul>';
        data.stores.forEach(function (store) {
            accessibleList += `<li>
                ${store.name}, ${store.address1}, ${store.city}, ${store.stateCode}, ${store.postalCode}, Phone: ${store.phone}
            </li>`;
        });
        accessibleList += '</ul></div>';
        $resultsDiv.append(accessibleList);
    }

    if ($('body').find('.js-preferred-store-page').length) {
        $('#inStoreInventoryModal').find('.store-note').addClass('d-none');
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');

    if ($('#radius').length > 0) {
        radius = $('#radius option:selected').val();
    }
    var postalCode = $form.find('[name="postalCode"]').val();
    if (postalCode === '') {
        postalCode = '90501';
        radius = '1000';
        $form
            .find('#store-postal-code-error')
            .show()
            .text('Please enter a zip code to search')
            .attr('role', 'alert') // ADA: announce validation error
            .attr('aria-live', 'assertive');
        spinner.stop();
        return false;
    }

    var urlParams = { radius: radius };
    var payload = $form.is('form')
        ? $form.serialize()
        : { postalCode: postalCode };
    url = appendToUrl(url, urlParams);

    if ($('#checkout-main').length > 0) {
        url = appendToUrl(url, { ischeckout: true });
    }

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        },
    });
    return false;
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('body').on('click', '.detect-location', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(
                function (position) {
                    var $detectLocationButton = $('.detect-location');
                    var url = $detectLocationButton.data('action');
                    var radius = $('.results').data('radius');
                    var urlParams = {
                        radius: radius,
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                    };
                    if (url) {
                        url = appendToUrl(url, urlParams);
                        $.ajax({
                            url: url,
                            type: 'get',
                            dataType: 'json',
                            success: function (data) {
                                $.spinner().stop();
                                updateStoresResults(data);
                                $('.select-store').prop('disabled', true);
                            },
                        });
                    } else {
                        var geocoder = new google.maps.Geocoder();
                        var latlng = new google.maps.LatLng(urlParams.lat, urlParams.long);
                        geocoder.geocode({ latLng: latlng }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]) {
                                    var zip;
                                    var postal = results[0].address_components.find((c) =>
                                        c.types.includes('postal_code')
                                    );
                                    if (postal) {
                                        zip = postal.long_name;
                                    } else {
                                        zip = results[0].formatted_address.match(
                                            /[A-Z]{2}\s+(\d{5}(?:-\d{4})?)/
                                        );
                                        if (zip.length > 1) {
                                            zip = zip[1];
                                        }
                                    }
                                    $('#store-postal-code').val(zip);
                                    $('.btn-storelocator-search').trigger('click');
                                }
                            }
                        });
                    }
                },
                function () {
                    $.spinner().stop();
                }
            );
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            $(this).closest('.store-locator').find('#store-postal-code-error').hide();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(
            function (e) {
                e.preventDefault();
                $(this)
                    .closest('.store-locator')
                    .find('#store-postal-code-error')
                    .hide();
                search($(this));
            }
        );
        $('.store-locator-container input').on('keypress', function (e) {
            $(this).closest('.store-locator').find('#store-postal-code-error').hide();
            if (e.key === 'Enter') {
                e.preventDefault();
                search($(this));
            }
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode,
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long,
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                },
            });
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data;
            if ($('#checkout-main').length) {
                data = {
                    storeID: selectedStore.val(),
                    searchRadius: $('#radius').val(),
                    searchPostalCode: $('.results').data('search-key').postalCode,
                    storeDetailsHtml: selectedStore
                        .siblings('label')
                        .find('.store-details')
                        .html(),
                    oostext: null,
                    event: e,
                };
            } else {
                data = {
                    storeID: selectedStore.val(),
                    searchRadius: $('#radius').val(),
                    searchPostalCode: $('.results').data('search-key').postalCode,
                    storeDetailsHtml: selectedStore
                        .siblings('label')
                        .find('.js-store-zip')
                        .html(),
                    oostext: null,
                    event: e,
                };
            }

            if (selectedStore.siblings('label').find('.js-oos-note').length > 0) {
                data.oostext = selectedStore
                    .siblings('label')
                    .find('.js-oos-note')
                    .html();
            }

            $('body').trigger('store:selected', data);
        });

        $('body').on('click', '.choose-store-btn', function (e) {
            e.preventDefault();
            $(this).closest('.card-body').find('.select-store-input').click();
            $('.store-locator-container .select-store').click();
        });
    },

    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', function () {
            $('.select-store').prop('disabled', false);
        });
    },
};
